import React, { type ReactElement, type ReactNode, isValidElement } from "react";
import { Container, Row, Col } from "shared-portal-component";

import '@/components/molecules/TwoSlot/TwoSlot.scss'

interface SlotProps {
  children?: ReactNode;
}

const FirstSlot: React.FC<SlotProps> = ({ children }) => <>{children}</>;
const SecondSlot: React.FC<SlotProps> = ({ children }) => <>{children}</>;

interface TwoSlotProps {
  children: ReactNode;
}

// Main component
export const TwoSlot: React.FC<TwoSlotProps> & {
  FirstSlot: typeof FirstSlot;
  SecondSlot: typeof SecondSlot;
} = ({ children }) => {
  let firstContent: ReactNode = null;
  let secondContent: ReactNode = null;

function isSlotElement(
  element: ReactNode
): element is ReactElement<{ children?: ReactNode }> {
  return isValidElement(element);
}

React.Children.forEach(children, (child) => {
  if (!isSlotElement(child)) return;
  const { props: {children: slotChildren} } = child;

  if (child.type === FirstSlot) firstContent = slotChildren;
  if (child.type === SecondSlot) secondContent = slotChildren;
});

  return (
    <Container className="container">
      <Row spacing="none">
        <Col size={6}>
          <div >{firstContent}</div>
        </Col>
        <Col size={6}>
          <div>{secondContent}</div>
        </Col>
      </Row>
    </Container>
  );
};

TwoSlot.FirstSlot = FirstSlot;
TwoSlot.SecondSlot = SecondSlot;

export default TwoSlot;
